const CONSTRUCTION = 'CONSTRUCTION';
const EOLIENNE = 'EOLIENNE';
const OTHER_VALUE = 'Autre';
const NO_ANSWER = 'N’a pas répondu';
const MINUMUM_DISTANCE = 5000;
const MAXIMUM_DISTANCE = 50000;
const DISTANCE_STEP = 5000;

const TYPE_PERTURBATEUR = {
  CONSTRUCTION: CONSTRUCTION,
  EOLIENNE: EOLIENNE,

  VALUES: [
    CONSTRUCTION,
    EOLIENNE
  ]
};

export { TYPE_PERTURBATEUR, OTHER_VALUE, NO_ANSWER, MINUMUM_DISTANCE, MAXIMUM_DISTANCE, DISTANCE_STEP};



// WEBPACK FOOTER //
// ./src/modules/prtv/model.js